import { PageType } from "@/types";
import styles from "@/styles/Video.module.scss";
import { useCallback, useEffect, useRef, useState } from "react";
import { ImageLoader } from "./ContentSections/ImageLoader";

export function VideoComponent({ page, onEnd }: { page: PageType; onEnd: () => void }) {
	const videoRef = useRef<HTMLVideoElement>(null);
	const [videoLoaded, setVideoLoaded] = useState(false);

	const origin = process.env.NEXT_PUBLIC_API_ORIGIN || "";

	const handleCanPlay = () => {
		setVideoLoaded(true);
	};

	// const [posterUrl, setPosterUrl] = useState<string | undefined>(undefined);
	// useEffect(() => {
	// 	if (page && page.video_poster) {
	// 		let poster = page.video_poster?.url;

	// 		if (page.video_poster.formats && Object.prototype.hasOwnProperty.call(page.video_poster.formats, "large") && page.video_poster.formats.large) {
	// 			poster = page.video_poster.formats.large.url;
	// 		}

	// 		setPosterUrl(process.env.NEXT_PUBLIC_API_ORIGIN + poster);
	// 	}
	// }, [page]);

	useEffect(() => {
		if (videoRef.current) {
			(videoRef.current as HTMLVideoElement).playbackRate = 1;
		}
	}, [videoRef]);

	// handle what happens on key press
	// const handleKeyPress = useCallback(
	// 	(event: KeyboardEvent) => {
	// 		if (event.key === "s" && confirm("Wollen Sie das Video wirklich skippen?")) {
	// 			onEnd();
	// 		}
	// 	},
	// 	[onEnd]
	// );
	// useEffect(() => {
	// 	// attach the event listener
	// 	document.addEventListener("keydown", handleKeyPress);

	// 	// remove the event listener
	// 	return () => {
	// 		document.removeEventListener("keydown", handleKeyPress);
	// 	};
	// }, [handleKeyPress]);

	const videoAlignTop30 = ["temporal-communities", "freie-universitaet-berlin"].includes(page?.slug);
	const videoAlignTop20 = ["technische-universitaet-berlin"].includes(page?.slug);
	const videoAlignTop10 = ["neurocure", "uni-sys-cat"].includes(page?.slug);
	const videoAlignTop = ["humboldt-universitaet-zu-berlin", "charite"].includes(page?.slug);

	useEffect(() => {
		if (!page.video) {
			onEnd();
		}
	}, [page, onEnd]);

	const handleEnded = () => {
		onEnd();
	};

	return (
		<div className={styles.container}>
			<ImageLoader />
			<video
				ref={videoRef}
				poster={origin + page.video_poster?.url}
				onEnded={handleEnded}
				controls={false}
				className={`${styles.video} ${videoAlignTop30 ? styles.positionTop30 : ""} ${videoAlignTop20 ? styles.positionTop20 : ""} ${videoAlignTop10 ? styles.positionTop10 : ""} ${videoAlignTop ? styles.positionTop : ""}`}
				onCanPlay={handleCanPlay}
				autoPlay
				muted
				playsInline
				preload="auto"
			>
				{page.video?.map((video) => {
					return <source key={video.id} src={process.env.NEXT_PUBLIC_API_ORIGIN + video.url} type={video.mime}></source>;
				})}
			</video>
		</div>
	);
}
